<div *ngFor="let pergunta of perguntas; let i = index">
    <p class="pergunta-titulo">Pergunta {{ i + 1 }}</p>
    <mat-divider class="mb-8"></mat-divider>

    <div class="form-group">
        <label class="pergunta-texto">{{ pergunta.avaliacao }}</label>
        <div *ngFor="let item of pergunta.possiveisRespostasAvaliacaoRequisito" class="radio-group">
            <input type="radio" 
                [id]="'resposta' + i + item.id" 
                [name]="'pergunta' + i" 
                [value]="item.id"
                (change)="selecionarResposta(pergunta.id, item.id)"
                [checked]="isRespostaSelecionada(pergunta.id, item.id)"
                [disabled]="disable">

            <label [for]="'resposta' + i + item.id" class="resposta-texto">{{ item.resposta }}</label>
        </div>
    </div>
</div>
